exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ETDHCK7RrZPD-e7NvDX9j {\n  border: 1px solid var(--border-color);\n  border-radius: 3px;\n  padding: 1px 8px;\n  flex-shrink: 0;\n  font-size: 12px;\n  line-height: 1.1rem;\n}\n\n.ETDHCK7RrZPD-e7NvDX9j svg{\n  width: 12px;\n  height: auto;\n}\n", ""]);
// Exports
exports.locals = {
	"badge": "ETDHCK7RrZPD-e7NvDX9j"
};